'use client';

import { usePathname, useRouter } from 'next/navigation';
import { addLocaleToPath, getLocaleFromPath, supportedLocales, type Locale } from '../lib/i18n/utils';

export default function LanguageSwitcher() {
  const pathname = usePathname();
  const router = useRouter();
  const currentLocale = getLocaleFromPath(pathname);

  const handleLanguageChange = (newLocale: Locale) => {
    if (newLocale === currentLocale) return;
    
    const newPath = addLocaleToPath(pathname, newLocale);
    router.push(newPath);
  };

  return (
    <div className="flex items-center gap-1.5 lg:gap-2 xl:w-[67px] xl:h-[26px] xl:justify-center">
      {supportedLocales.map((locale) => (
        <button
          key={locale}
          onClick={() => handleLanguageChange(locale)}
          className={`nav-link text-[0.8125rem] xl:text-sm text-brand-text ${
            currentLocale === locale ? 'is-active' : ''
          }`}
          data-text={locale.toUpperCase()}
          // aria-label should match visible text to avoid accessibility mismatch
          // The visible text is the locale code (EL/EN), so aria-label should match it
          aria-label={locale.toUpperCase()}
          type="button"
        >
          <span>{locale.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
}

